import { Component, HostListener } from '@angular/core';
import { IMenuItem } from '../header-bottom/header-bottom.component';
import { CLASS_ACTIVE, CLASS_EMPTY, CLASS_SHOW } from '../../../shared-third-party/consts';
import { HeaderService } from '../header.service';

@Component({
    selector: 'app-header-fixed',
    templateUrl: './header-fixed.component.html',
    styleUrl: './header-fixed.component.scss'
})
export class HeaderFixedComponent {
    menuItems: IMenuItem[] = [
        {
            'title': 'Новостройки',
            'href': "/novostrojki/",
            'id': 'newbuilding'
        },
        {
            'title': 'Вторичка',
            'href': "/kupit-kvartiru/flats#noscroll",
            'id': 'resale'
        },
        {
            'title': 'Коммерческая',
            'href': "/commercial#noscroll",
            'id': 'commercial'
        },
        {
            'title': 'Застройщикам',
            'href': "/zastrojshhikam",
            'id': 'zastrojshhikam'
        },
        {
            'title': 'Подбор квартиры',
            'href': "/podbor",
            'id': 'all'
        },
        {
            'title': 'Ипотека',
            'href': "/ipoteka",
            'id': 'mortgage'
        },
        {
            'title': 'Консалтинг',
            'href': "/konsalting-i-analitika",
            'id': 'zastrojsshikam'
        },
        {
            'title': 'Контакты',
            'href': "/kontakty",
            'id': 'services'
        },
    ];
    fixedNavbarClass = CLASS_EMPTY;
    favouritesCount = 0;
    subMenuActiveClass = CLASS_EMPTY;

    constructor(private headerService: HeaderService) {
    }
    @HostListener("window:scroll", []) onWindowScroll() {
        this.fixedNavbarClass = window.pageYOffset > 100 ? CLASS_SHOW : CLASS_EMPTY;
    }

    getNoFavouritesClass(): string {
      return this.favouritesCount > 0 ? '' : 'no-favorites';
    }

  showCalltouchWidget() {
    this.headerService.showCalltouchWidget();
  }

  isOldHeader(): boolean {
    return this.headerService.isOldHeader();
  }

  showMobileMenu(): void {
    this.subMenuActiveClass = CLASS_ACTIVE;
  }
}
